// extracted by css-extract-rspack-plugin
export default {"root":"nCL8B","selected":"RreNq"};